import { makeAutoObservable } from 'mobx'
import { GetPatientDocuments } from 'domain/usecases/patient/get-patient-documents'

type Services = {
  getPatientDocuments: GetPatientDocuments
}

export class PatientDocumentService {
  constructor(private readonly services: Services) {
    makeAutoObservable(this)
  }

  async getPatientDocuments(
    params: GetPatientDocuments.Params
  ): Promise<GetPatientDocuments.Model> {
    return this.services.getPatientDocuments.get(params)
  }
}

export default PatientDocumentService
